import { Row, Col, Modal } from "antd";
import React from "react";
import { useSelector } from "react-redux";
//
//component
import PaymentInfo from "./component/payment_info";
import PaymentQR from "./component/payment_qr";
import PaymentSuccess from "./component/paymen_success";
import PaymentDetail from "./component/payment_detail";
import TriggerInit from "./trigger/trigger_init";
import PaymentAction from "./component/payment_action";
//redux
//selector
import { bailiffDocumentOpenPaySelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//actions
//utils
//hook
import { useBailiffPayment } from "hook/bailiff/document/action/useBailiffPayment";
import { useFlow, FLOWS } from "hook/bailiff/document/flow/useFlow";

//str
const DialogPaymentQR = () => {
  // -------------------------- VAR -----------------------------
  const { handleClose } = useBailiffPayment();
  const { flow } = useFlow();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(bailiffDocumentOpenPaySelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLocked = () => {
    const isLocked = flow === FLOWS.LOCKED;
    if (!isLocked) return null;
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <PaymentQR />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <PaymentInfo />
        </Col>
        <Col align="center" xl={24} lg={24} md={24} xs={24}>
          <PaymentAction />
        </Col>
      </Row>
    );
  };

  const renderUnlocked = () => {
    const isPaid = flow === FLOWS.PAID;
    if (!isPaid) return null;
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <PaymentSuccess />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <PaymentInfo />
        </Col>
        <Col align="center" xl={24} lg={24} md={24} xs={24}>
          <PaymentDetail />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      closable={false}
      open={open}
      onCancel={handleClose}
      width={550}
      title={null}
      footer={null}
    >
      {renderLocked()}
      {renderUnlocked()}
      <TriggerInit />
    </Modal>
  );
};
export default DialogPaymentQR;
